export default {"src":"/_next/static/media/Fully-Digital.e626dfab.svg","height":136,"width":175};